<template>
<!--    微信分享引导弹窗-->
    <van-popup
        style="background: transparent"
        :value="value"
        :showConfirmButton="false"
        position="top"
        :overlay="true"
        @click-overlay="$emit('input', false)">
          <div class="main">
            <div class="content">
                <img class="content_img" src="./img/network.png" alt="">
                <div class="content_word">
                    点击右上角<br>
                    分享至好友
                </div>
            </div>
          </div>
    </van-popup>
</template>
<script>
    import { Popup  as VanPopup } from 'vant'

    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        components: { VanPopup }
    }
</script>
<style lang="scss" scoped>
.main {
    width: 100%;
    height: 90px;
    position: relative;
    .content {
        position: absolute;
        top: 15px;
        right: 16px;
        width: 145px;
        height: 70px;
        box-shadow:0 5px 15px 0 rgba(0, 0, 0, 0.08);
        border-top-left-radius:5px;
        border-bottom-left-radius:5px;
        border-bottom-right-radius: 5px;
        background: #ffffff;
        display: flex;
        align-items: center;
        &:before {
            position: absolute;
            top: -5px;
            right: 0;
            content: '';
            width: 0;
            height: 0;
            border: 6px solid;
            border-color: transparent #ffffff transparent transparent;
            z-index: -1;
        }

        &_img {
            width: 39px;
            height: 39px;
            margin-left: 6px;
        }
        &_word {
            margin-left: 4px;
            font-size:14px;
            font-weight:400;
            color:rgba(34,34,34,1);
            line-height:18px;
            &>span {
                color: #F84025;
            }
        }
    }
}

</style>
